import React, { useState } from 'react';
import '../styles/components.css';

const AccessGate = ({ onAccessGranted }) => {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (code === '14011') {
      onAccessGranted();
    } else {
      setError('Code mismatch - Please try again');
      //setError('Portal validity Expired - Please pay and renew Rs 50,000/per year');
    }
  };

  return (
    <div className="access-gate">
      <div className="access-container">
        <div className="access-header">
          <h1>Railway Exam Portal</h1>
          <p>Enter the access code to proceed</p>
        </div>
        <form className="access-form" onSubmit={handleSubmit}>
          <div className="input-group">
            <input
              type="password"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              placeholder="Enter Access Code"
              required
              className="access-input"
            />
          </div>
          <button type="submit" className="access-button">Access Portal</button>
        </form>
        {error && <p className="error-message">{error}</p>}
      </div>
    </div>
  );
};

export default AccessGate;